module.exports = "https://cdn2-fs.clearscore.com/flux/images/0546d5b44685120ccb557a58f001734d.jpg";